import React from 'react'
import LogoImg from '../../../assets/login/logo.png'
import { Phrase, Phrase2, Logo, LogoDiv, Img, Container } from './style'
// import { Logo } from '../style2'

const Validation: React.FC = () => {
  return (
    <>
      <Img></Img>
      <Container>
        <LogoDiv>
          <Logo src={LogoImg} alt='Logo da Dustre' />
        </LogoDiv>
        <div>
          <Phrase>
            <h2>Seu cadastro está em processo de validação</h2>
          </Phrase>
        </div>
        <div>
          <Phrase2>
            <p>
              Nossa equipe está trabalhando para revisar suas informações e
              liberar seu acesso o mais rápido possível.
            </p>
            <br />
            <p>
              Caso precise de suporte ou queira obter atualizações sobre o
              status do seu cadastro,sinta-se à vontade para nos contatar por
              email em [suporte@dustre.com.br].
            </p>
            <br />
            Agradecemos pela sua paciência!
          </Phrase2>
        </div>
      </Container>
    </>
  )
}

export default Validation
